<template>
  <div v-if="isVisible" class="modal d-block" style="background-color: rgba(0,0,0,0.5); z-index: 9999;">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <!-- Loading State -->
          <div v-if="isLoading" class="text-center py-4">
            <div class="my-4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h4 class="mb-2">
              Mengupload Produk
            </h4>
            <p class="mb-4">
              Jangan tutup halaman ini, data sedang disinkronisasi.
            </p>
          </div>

          <!-- Success State -->
          <div v-else class="text-center py-4">
            <div class="my-4">
              <div class="rounded-circle bg-success d-inline-flex align-items-center justify-content-center" style="width: 64px; height: 64px;">
                <i class="material-icons text-white" style="font-size: 32px;">check</i>
              </div>
            </div>
            <h5 class="mb-4">
              Berhasil
            </h5>
            <button
              @click="handleClose"
              class="btn btn-primary mt-4 w-50"
            >
              Ok, Mengerti
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'LoadingAddProduct',
	props: {
		isVisible: {
			type: Boolean,
			default: false,
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		handleClose() {
			this.$router.push('/products');
		},
	},
};
</script>
